<div [appPreventClickOnCondition]="shouldAllowClick" [class.disabled]="!shouldAllowClick()">
  @if (printProduct) {
  <div id="no-folders-section" class="flex flex-col gap-5">
    <div>
      <!-- Selector -->
      <div class="mb-3 flex justify-end">
        <div class="price-tabs">
          <button
            class="price-tab"
            [class.active]="selectedPriceTab === 'folder'"
            (click)="selectedPriceTab = 'folder'"
          >
            Total carpeta
          </button>
          <button
            class="price-tab"
            [class.active]="selectedPriceTab === 'cart'"
            [class.cart]="selectedPriceTab === 'cart'"
            (click)="selectedPriceTab = 'cart'"
          >
            Total del carrito
          </button>
        </div>
      </div>

      <!-- Tarjeta de precio-->
      <div class="price-card" [class.price-card--expanded]="selectedPriceTab === 'cart'">
        <!-- Tab: Esta carpeta -->
        <ng-container *ngIf="selectedPriceTab === 'folder'">
          <span class="price-card_label price-card_label--secondary">Esta carpeta:</span>
          <span class="price-card_price league-spartan">{{
            this.printProduct.price.amt | currency: this.cartService.cart.price.cur : 'symbol' : '1.2-2'
          }}</span>
        </ng-container>
        <!-- Tab: Total del carrito (muestra ambas filas) -->
        <ng-container *ngIf="selectedPriceTab === 'cart'">
          <div class="price-card_row">
            <span class="price-card_label barlow">Esta carpeta:</span>
            <span class="price-card_price price-card_price--secondary league-spartan">{{
              this.printProduct.price.amt | currency: this.cartService.cart.price.cur : 'symbol' : '1.2-2'
            }}</span>
          </div>
          <div class="price-card_row">
            <span class="price-card_label barlow">Total del carrito:</span>
            <span class="price-card_price league-spartan">{{
              cartTotal | currency: this.cartService.cart.price.cur : 'symbol' : '1.2-2'
            }}</span>
          </div>
        </ng-container>
      </div>
      <!--  aquí el texto: "el descuento se aplicará en el carrito" -->
    </div>
    <ion-button class="go-cart-button flex" (click)="cartService.openCartPreviewMenu()" color="dark">
      <ion-icon icon="assets/icon/carrito.svg"></ion-icon>
      <span class="barlow">Guardar e ir al carrito</span>
    </ion-button>
    <hr />
    <div class="commentBox">
      <ion-label class="commentBox_label barlow">Añade un comentario</ion-label>
      <ion-textarea
        class="commentBox_textarea barlow"
        [autoGrow]="false"
        [counter]="true"
        maxlength="500"
        rows="2"
        placeholder="Escribe aquí tu comentario"
        debounce="1500"
        (ionInput)="cartService.saveCart(this.cartService.cart)"
        (ionFocus)="cartService.showConfirmCommentInfo($event)"
        [(ngModel)]="printProduct.product.printingGroup.comment"
      >
        <!--OLD PLACEHOLDER Al incluir comentarios, debemos valorar la viabilidad de la solicitud por lo que el proceso de entrega podría alargarse hasta dos días laborables más. Si tienes dudas contacta a través de nuestro chat.-->
      </ion-textarea>
    </div>
    <hr style="margin-bottom: 20px" />
  </div>
  }
  <div class="groups flex flex-col gap-5">
    <div class="flex flex-row items-center justify-between">
      <div class="groups_title flex flex-row items-center justify-start">
        <ion-icon
          [id]="'tooltip-icon-folders'"
          class="tooltip-icon"
          color="black"
          src="assets/icon/info.svg"
        ></ion-icon>
        <h2 class="raleway">Mis carpetas</h2>
        <ion-popover
          [trigger]="'tooltip-icon-folders'"
          class="info-popover"
          triggerAction="click"
          showBackdrop="true"
          animated="true"
        >
          <ng-template>
            <app-tooltip-info-folders></app-tooltip-info-folders>
          </ng-template>
        </ion-popover>
      </div>
    </div>
    <div
      class="groups_list flex flex-col gap-2.5"
      #groupsList
      [ngStyle]="{ height: scrollHeight + 'px' }"
      (scroll)="appS.closeAllTooltips()"
    >
      <ion-button class="create-group-button flex" (click)="reload()" color="tertiary" fill="solid">
        <ion-icon icon="assets/icon/add.svg"></ion-icon>
        <span class="barlow">Crear otra carpeta</span>
      </ion-button>
      <app-print-group-folder-item
        *ngFor="let group of printGroupItems().reverse()"
        [currentPrintProduct]="printProduct"
        [group]="group"
        [isLoading]="isLoading"
      ></app-print-group-folder-item>
    </div>
  </div>
</div>
